(function () {
  'use strict';

  var elementName = 'swym-wishlist-button';
  var addLabel = 'お気に入りに追加';
  var removeLabel = 'お気に入りから削除';
  var fetchErrorMessage = 'お気に入りの状態を取得できませんでした。';
  var updateErrorMessage = 'お気に入りを更新できませんでした。もう一度お試しください。';
  var swatInstance = null;

  if (!window.customElements || window.customElements.get(elementName)) {
    return;
  }

  function normalizeId(value) {
    return value === null || typeof value === 'undefined' ? '' : String(value);
  }

  function getProductKey(product) {
    return normalizeId(product && product.empi) + ':' + normalizeId(product && product.epi);
  }

  function getVariantUrl(productUrl, variantId) {
    var url;

    if (!productUrl || !variantId) {
      return productUrl;
    }

    try {
      url = new URL(productUrl, window.location.origin);
      url.searchParams.set('variant', variantId);
      return url.toString();
    } catch (error) {
      return productUrl;
    }
  }

  function getCanonicalProductUrl(productUrl) {
    var url;

    if (!productUrl) {
      return productUrl;
    }

    try {
      url = new URL(productUrl, window.location.origin);
      url.search = '';
      url.hash = '';
      return url.toString();
    } catch (error) {
      return productUrl.split('?')[0].split('#')[0];
    }
  }

  function getVariantTitle(product, variant) {
    var variantTitle = product && product.vi;

    if (!variantTitle && product && Array.isArray(product.variants) && product.variants[0]) {
      variantTitle = Object.keys(product.variants[0])[0];
    }

    if (!variantTitle && variant) {
      variantTitle = variant.title;
    }

    return variantTitle && variantTitle !== 'Default Title' ? variantTitle : '';
  }

  function getPageProduct() {
    var pageData = window.SwymPageData;

    if (!pageData || Number(pageData.et) !== 1 || !pageData.empi || !pageData.epi || !pageData.du) {
      return null;
    }

    return {
      empi: pageData.empi,
      epi: pageData.epi,
      du: getVariantUrl(pageData.du, pageData.epi),
      dt: pageData.dt,
      iu: pageData.iu,
      pr: pageData.pr,
      ct: pageData.ct,
      stk: pageData.stk,
      op: pageData.op,
      variants: pageData.variants,
      vi: getVariantTitle(pageData),
      source: 'pdp'
    };
  }

  function getVariantProduct(product, variant) {
    var variantData = window.SwymProductVariants && window.SwymProductVariants[variant.id];
    var variantId = variantData && variantData.epi ? variantData.epi : variant.id;
    var variantUrl = variantData && variantData.du ? variantData.du : product.du;

    return {
      empi: product.empi,
      epi: variantId,
      du: getVariantUrl(variantUrl, variantId),
      dt: variantData && variantData.dt ? variantData.dt : product.dt,
      iu: variantData && variantData.iu ? variantData.iu : product.iu,
      pr: variantData && typeof variantData.pr !== 'undefined' ? variantData.pr : variant.price / 100,
      ct: variantData && variantData.ct ? variantData.ct : product.ct,
      stk: variantData && typeof variantData.stk !== 'undefined' ? variantData.stk : product.stk,
      op: variantData && typeof variantData.op !== 'undefined' ? variantData.op : product.op,
      variants: variantData && variantData.variants ? variantData.variants : product.variants,
      vi: getVariantTitle(variantData, variant),
      source: 'pdp',
      _cv: true
    };
  }

  function copyProduct(product) {
    return {
      empi: product.empi,
      epi: product.epi,
      du: product.du,
      dt: product.dt,
      iu: product.iu,
      pr: product.pr,
      ct: product.ct,
      stk: product.stk,
      op: product.op,
      variants: product.variants,
      vi: product.vi,
      source: product.source,
      _cv: product._cv
    };
  }

  function copyListProduct(product) {
    return {
      empi: product.empi,
      epi: product.epi,
      du: getCanonicalProductUrl(product.du)
    };
  }

  class SwymWishlistButton extends HTMLElement {
    constructor() {
      super();
      this.button = null;
      this.label = null;
      this.status = null;
      this.productSection = null;
      this.product = null;
      this.swat = null;
      this.isWishlisted = false;
      this.requestToken = 0;
      this.wishlistStates = new Map();
      this.wishlistItems = new Map();
      this.listenersConnected = false;
      this.handleClick = this.handleClick.bind(this);
      this.handleVariantChange = this.handleVariantChange.bind(this);
    }

    connectedCallback() {
      this.button = this.querySelector('.swym-wishlist-button__button');
      this.label = this.querySelector('[data-swym-wishlist-label]');
      this.status = this.querySelector('[data-swym-wishlist-status]');
      this.productSection = this.closest('[data-section-type="product"]');
      if (!this.button || this.listenersConnected) {
        return;
      }
      this.button.addEventListener('click', this.handleClick);
      if (this.productSection) {
        this.productSection.addEventListener('variantChange', this.handleVariantChange);
      }
      this.listenersConnected = true;

      if (swatInstance) {
        this.initializeSwym(swatInstance);
      }
    }

    disconnectedCallback() {
      this.requestToken += 1;

      if (!this.listenersConnected) {
        return;
      }

      this.button.removeEventListener('click', this.handleClick);
      if (this.productSection) {
        this.productSection.removeEventListener('variantChange', this.handleVariantChange);
      }
      this.listenersConnected = false;
    }

    initializeSwym(swat) {

      if (!this.isConnected || !this.button) {
        return;
      }

      this.swat = swat;
      this.product = this.product || getPageProduct();

      if (!this.product) {
        console.error('Swym wishlist: Product data is unavailable.');
        return;
      }

      this.refreshState();
    }

    refreshState() {
      var requestProduct = copyProduct(this.product);
      var requestKey = getProductKey(requestProduct);
      var requestToken = ++this.requestToken;

      this.setBusy(true);
      this.swat.fetch(
        function (wishlistedProducts) {
          var products = Array.isArray(wishlistedProducts) ? wishlistedProducts : [];
          this.wishlistStates.clear();
          this.wishlistItems.clear();
          products.forEach(function (product) {
            if (normalizeId(product.empi) === normalizeId(requestProduct.empi)) {
              this.wishlistStates.set(getProductKey(product), true);
              this.wishlistItems.set(getProductKey(product), product);
            }
          }, this);

          if (!this.isCurrentRequest(requestToken, requestKey)) {
            return;
          }

          this.updateState(this.wishlistStates.has(requestKey));
          this.setBusy(false);
        }.bind(this),
        function (error) {
          console.error('Swym wishlist: Unable to fetch wishlist state.', error);

          if (!this.isCurrentRequest(requestToken, requestKey)) {
            return;
          }

          this.announce(fetchErrorMessage);
          this.setBusy(false);
        }.bind(this)
      );
      
    }

    handleClick() {
      if (!this.swat || !this.product || this.button.disabled) {
        return;
      }
      var requestProduct = copyProduct(this.product);
      var requestKey = getProductKey(requestProduct);
      var requestToken = ++this.requestToken;
      var wasWishlisted = this.isWishlisted;
      var method = wasWishlisted ? 'removeFromWishList' : 'addToWishList';
      var siblingListId = wasWishlisted ? null : this.getSiblingListId(requestProduct);
      var useSiblingList = siblingListId && typeof this.swat.addToList === 'function';
      console.log(siblingListId);
      if (
        this.swat.retailerSettings &&
        this.swat.retailerSettings.General &&
        this.swat.retailerSettings.General.ProductLevel
      ) {
        requestProduct.type = this.swat.retailerSettings.General.ProductLevel;
      }

      this.setBusy(true);
      var onSuccess = function (updatedProduct) {
        var nextState = !wasWishlisted;
        var confirmedProduct = Object.assign({}, requestProduct);

        if (nextState) {
          if (siblingListId) {
            confirmedProduct.lid = siblingListId;
          }
          this.wishlistStates.set(requestKey, true);
          this.wishlistItems.set(requestKey, confirmedProduct);
        } else {
          this.wishlistStates.delete(requestKey);
          this.wishlistItems.delete(requestKey);
        }

        if (!this.isCurrentRequest(requestToken, requestKey)) {
          return;
        }

        this.updateState(nextState);
        this.announce(nextState ? 'お気に入りに追加しました。' : 'お気に入りから削除しました。');
        this.setBusy(false);
        document.dispatchEvent(new CustomEvent('swym:wishlist:changed'));
      }.bind(this);
      var onError = function (error) {
        console.error('Swym wishlist: Unable to update wishlist.', error);

        if (!this.isCurrentRequest(requestToken, requestKey)) {
          return;
        }

        this.updateState(wasWishlisted);
        this.announce(updateErrorMessage);
        this.setBusy(false);
      }.bind(this);

      if (useSiblingList) {
        this.swat.addToList(siblingListId, copyListProduct(requestProduct), onSuccess, onError);
        return;
      }

      this.swat[method](
        requestProduct,
        onSuccess,
        onError
      );
    }

    getSiblingListId(product) {
      var productKey = getProductKey(product);
      var listId = null;

      this.wishlistItems.forEach(function (item, itemKey) {
        if (
          !listId &&
          itemKey !== productKey &&
          normalizeId(item.empi) === normalizeId(product.empi) &&
          item.lid
        ) {
          listId = item.lid;
        }
      });

      return listId;
    }

    handleVariantChange(event) {
      var variant = event.detail && event.detail.variant;
      var baseProduct = this.product || getPageProduct();

      if (!variant || !baseProduct) {
        return;
      }

      this.product = getVariantProduct(baseProduct, variant);
      var cachedState = this.wishlistStates.get(getProductKey(this.product));
      this.updateState(typeof cachedState === 'boolean' ? cachedState : false);

      if (this.swat) {
        this.refreshState();
      }
    }

    isCurrentRequest(requestToken, requestKey) {
      return this.isConnected && requestToken === this.requestToken && requestKey === getProductKey(this.product);
    }

    setBusy(isBusy) {
      this.button.setAttribute('aria-busy', String(isBusy));
      this.button.disabled = isBusy || !this.swat || !this.product;
    }

    updateState(isWishlisted) {
      var label = isWishlisted ? removeLabel : addLabel;

      this.isWishlisted = isWishlisted;
      this.classList.toggle('is-wishlisted', isWishlisted);
      this.button.setAttribute('aria-pressed', String(isWishlisted));
      this.button.setAttribute('aria-label', label);
      if (this.label) {
        this.label.textContent = label;
      }
    }

    announce(message) {
      if (!this.status) {
        return;
      }

      this.status.textContent = '';
      window.setTimeout(function () {
        if (this.status) {
          this.status.textContent = message;
        }
      }.bind(this), 0);
    }
  }

  window.customElements.define(elementName, SwymWishlistButton);

  // Executed after Swym has loaded all necessary resources.
  function onSwymLoadCallback(swat) {
    swatInstance = swat;
    document.querySelectorAll(elementName).forEach(function (element) {
      element.initializeSwym(swat);
    });


  }

  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(onSwymLoadCallback);
})();
